import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Image from 'common/components/Image';
import Heading from 'common/components/Heading';
import {
	DemoListWrapper,
	ProductCard,
	ImageWrapper,
	ButtonWrapper,
	Badge,
} from './style';

import { useStaticQuery, graphql } from 'gatsby';

const DemoList = ({ titleStyle, itemTitle, row, col }) => {
	const Data = useStaticQuery(graphql`
		query {
			dataJson {
				ProductShowcase {
					id
					title
					gatsbyLink
					nextLink
					badge
					thumb_url {
						publicURL
						childImageSharp {
							fluid(quality: 100) {
								...GatsbyImageSharpFluid
							}
						}
					}
				}
			}
		}
	`);

	const [state, setState] = useState({
		gatsby: true,
		next: false,
	});

	const addActiveClass = (type) => {
		if (type !== 'gatsby') {
			setState({
				...state,
				gatsby: false,
				next: true,
			});
		} else {
			setState({
				...state,
				gatsby: true,
				next: false,
			});
		}
	};

	const removeActiveClass = () => {
		setState({
			...state,
			gatsby: true,
			next: false,
		});
	};
	console.log(Data, 'data');
	return (
		<DemoListWrapper>
			<Heading content="Explore All demos" {...titleStyle} />
			<Box {...row} style={{ boxSizing: 'border-box' }}>
				{Data.dataJson.ProductShowcase.map((product) => (
					<Box
						{...col}
						className={product.className}
						key={`item_key-${product.id}`}
					>
						<ProductCard>
							<ImageWrapper>
								{product.badge && (
									<Badge className="badge">{product.badge}</Badge>
								)}
								<ButtonWrapper className="btn_wrapper">
									<a
										href={product.gatsbyLink}
										className={state.gatsby ? 'active' : ''}
										target="_blank"
										onMouseEnter={() => addActiveClass('gatsby')}
										onMouseLeave={removeActiveClass}
										rel="noopener noreferrer"
									>
										Gatsby Demo
									</a>
									<a
										href={product.nextLink}
										className={state.next ? 'active' : ''}
										target="_blank"
										onMouseEnter={() => addActiveClass('next')}
										onMouseLeave={removeActiveClass}
										rel="noopener noreferrer"
									>
										Next js Demo
									</a>
								</ButtonWrapper>
								<Image
									src={product.thumb_url.publicURL}
									alt={`item_key-${product.id}`}
								/>
							</ImageWrapper>
							<Heading content={product.title} {...itemTitle} />
						</ProductCard>
					</Box>
				))}
			</Box>
		</DemoListWrapper>
	);
};

// DemoList style props
DemoList.propTypes = {
	row: PropTypes.object,
	col: PropTypes.object,
	titleStyle: PropTypes.object,
	itemTitle: PropTypes.object,
};

// DemoList default style
DemoList.defaultProps = {
	row: {
		flexBox: true,
		flexWrap: 'wrap',
		ml: '-15px',
		mr: '-15px',
		boxSizing: 'border-box',
	},
	col: {
		width: [1, 1 / 2, 1 / 2, 1 / 3, 1 / 3],
		pl: '15px',
		pr: '15px',
		mb: '50px',
	},
	titleStyle: {
		fontSize: '24px',
		fontWeight: '400',
		color: '#0f2137',
		letterSpacing: '-0.025em',
		textAlign: 'center',
		mb: '50px',
	},
	itemTitle: {
		fontSize: '16px',
		color: '#0f2137',
		fontWeight: '600',
		letterSpacing: '-0.025em',
		textAlign: 'center',
	},
};

export default DemoList;
